import { OrderStatus } from '../types';

export const determineOrderStatus = (
  dataAprovado: string | null,
  dataFaturado: string | null,
  dataEntregue: string | null,
  dataCancelado: string | null
): OrderStatus => {
  if (dataCancelado) {
    return 'cancelado';
  }

  if (dataEntregue) {
    return 'entrega';
  }

  if (dataFaturado) {
    return 'faturamento_realizado';
  }

  if (dataAprovado) {
    return 'pagamento_aprovado';
  }

  return 'pedido_realizado';
};
